import axios from 'axios';

export default class PeopleManagementService {
  public static getAllRoles(): Promise<any> {
    return axios.get('/api/v1/people-management/roles').then((response) => response.data);
  }

  public static getAllSeniorities(): Promise<any> {
    return axios.get('/api/v1/people-management/seniorities').then((response) => response.data);
  }
}
